import React, { Component } from 'react'
import { Container } from 'components/layout/Grid/'
import Heading from 'components/Heading'
import Banner from 'components/Banner'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

class UnauthorisedPage extends Component {
  render() {
    const bannerName = 'Unauthorise access'
    return (
      <div>
        <Banner name={bannerName} />
        <Container>
          <Heading size="large" />
        </Container>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
})

export default withRouter(connect(mapStateToProps, {
})(UnauthorisedPage))



// WEBPACK FOOTER //
// ./src/containers/UnauthorisedPage.js